import { Injectable } from "@angular/core";
import { getMatIconFailedToSanitizeLiteralError } from "@angular/material/icon";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { BehaviorSubject, Observable } from "rxjs";


export interface FileData {
    dmsId?: string;
    fileName: string;
    fileContent: string;
    mimeType: string;
    url?: SafeUrl;
}

@Injectable({
    providedIn: 'root'
})
export class FileUploadDownloadService {

    private fileData =new  BehaviorSubject<FileData>(null);
    public fileData$ = this.fileData.asObservable();
    constructor( private domSanitizer: DomSanitizer) {

    }

    readDocument(event) {
        if (!!!event.target.files || !!!event.target.files[0]) {
            return;
        }
        let files = event.target.files;

        var ext = "." + files[0].name.split('.').pop();
        var data: FileData = {
            fileName: files[0].name,
            fileContent: null,
            mimeType: files[0].type
        };

        var reader = new FileReader();
        reader.onload = (readerEvt: any) => {
            var binaryString = readerEvt.target.result;
            data.fileContent = btoa(binaryString);  // Converting binary string data.\
           data.url = this.domSanitizer.bypassSecurityTrustUrl("data:" +  data.mimeType + ";base64," + data.fileContent)

           
            this.fileData.next(data);
        }
        reader.readAsBinaryString(files[0]);
        event.target.value = '';

    }
  
    clearData() {
        this.fileData.next(null);
      }
    downloadFile(doc: FileData) {

        let newBlob = this.base64ToBlob(doc.fileContent, doc.mimeType);

        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        // window.open(data, '_blank');
        link.download = doc.fileName;
        link.click();
    }

    returnUrlOnly(data: FileData) {
       return this.domSanitizer.bypassSecurityTrustUrl("data:" +  data.mimeType + ";base64," + data.fileContent)
    }

    base64ToBlob(base64, mimeType) {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; ++i) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return new Blob([bytes], { type: mimeType });

    }

}